const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8081/api';

function getToken(): string {
  return localStorage.getItem('token') || '';
}

export type AssetRenameCategory = 'character' | 'scene' | 'prop';

export interface AssetRenameRequest {
  category: AssetRenameCategory;
  oldName: string;
  newName: string;
}

export interface AssetRenameImpact {
  analysisRows: number;
  shotAssetRefs: number;
  shotVersionAssetRefs: number;
  promptsStale: number;
  assetReviews: number;
  assetSearchTasks: number;
  styleTests: number;
  assetComments: number;
  disabledAssetsUpdated: boolean;
  imageTasksBlocking: string[] | null;
  advancedAnalysisBlocking: boolean;
}

export class AssetRenameError extends Error {
  status: number;
  taskIds: string[];
  constructor(message: string, status: number, taskIds: string[] = []) {
    super(message);
    this.name = 'AssetRenameError';
    this.status = status;
    this.taskIds = taskIds;
  }
}

async function callRename(
  projectId: string,
  path: string,
  method: 'POST' | 'PUT',
  body: AssetRenameRequest,
): Promise<AssetRenameImpact> {
  const token = getToken();
  const res = await fetch(`${API_BASE}/projects/${projectId}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (res.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new AssetRenameError('未登录', 401);
  }
  const payload = await res.json().catch(() => ({ error: 'Request failed' }));
  if (!res.ok) {
    const taskIds = Array.isArray(payload?.taskIds) ? payload.taskIds : [];
    throw new AssetRenameError(payload?.error || 'Request failed', res.status, taskIds);
  }
  return payload as AssetRenameImpact;
}

export const previewAssetRename = (projectId: string, req: AssetRenameRequest): Promise<AssetRenameImpact> =>
  callRename(projectId, '/analysis/element/rename/preview', 'POST', req);

export const applyAssetRename = (projectId: string, req: AssetRenameRequest): Promise<AssetRenameImpact> =>
  callRename(projectId, '/analysis/element/rename', 'PUT', req);
